import { Rich } from "@/components/Rich";
import { withDefaults } from "@/lib/sections";
import { SectionShell, Img } from "./shared";

export const TextImageSection = ({ id, content }) => {
  const c = withDefaults("text_image", content);
  return (
    <SectionShell id={`s-${id}`} testId={`custom-section-${id}`}>
      <div className={`grid items-center gap-10 lg:grid-cols-2 ${c.image_side === "left" ? "lg:[&>*:first-child]:order-2" : ""}`}>
        <div>
          {c.eyebrow && <div className="mb-3 font-mono text-xs text-orange-400">{c.eyebrow}</div>}
          <h2 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl"><Rich text={c.title} /></h2>
          <p className="mt-4 whitespace-pre-line leading-relaxed text-slate-400">{c.body}</p>
          {c.button_label && (
            <a href={c.button_url || "#"} className="mt-8 inline-flex rounded-lg bg-orange-500 px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-orange-600" data-testid={`custom-section-btn-${id}`}>
              {c.button_label}
            </a>
          )}
        </div>
        {c.image ? (
          <Img src={c.image} className="w-full rounded-2xl border border-white/10 object-cover shadow-2xl" />
        ) : (
          <div className="tech-grid aspect-video rounded-2xl border border-dashed border-white/10" />
        )}
      </div>
    </SectionShell>
  );
};

export default TextImageSection;
